import React, {useEffect} from "react";
import {useHistory, useLocation} from "react-router-dom";
import { parse } from "qs";
import pay from '../../images/wxpay.png'

function getIsWxClient() {
    const ua = navigator.userAgent.toLowerCase();
    // @ts-ignore
    if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
        return true;
    }
    return false;
}

export function getVisibilityName(){
    let visibilityChange:string;
    if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
        visibilityChange = "visibilitychange";
        // @ts-ignore
    } else if (typeof document.msHidden !== "undefined") {
        visibilityChange = "msvisibilitychange";
    } else {
        // @ts-ignore
        if (typeof document.webkitHidden !== "undefined") {
            visibilityChange = "webkitvisibilitychange";
        }
    }
    // @ts-ignore
    return visibilityChange
}

function DoWxPay(){
    const params = useLocation()
    const url = parse(params.search.replace(/\?/,''))
    const { replace } = useHistory()

    const pageShow = () => {
       if(!document["hidden"]){
           const redirect_url = new URL((url.url as string))
           const _params = parse(redirect_url.search.replace(/\?/,''))
           const u = new URL((_params.redirect_url as string))
           replace(`/wx${ u.search }`)
       }
    }

    useEffect(() => {
        if(!getIsWxClient() && url){
            window.location.href = (url.url as string)
        }
        document.addEventListener(getVisibilityName(),pageShow,false)
        return () => {
            document.removeEventListener(getVisibilityName(),pageShow,false)
        }
    },[])

    return <div className="wx-pay">
        <img src={ pay } alt=""/>
    </div>
}

export default DoWxPay
